import React, { Component } from 'react'

import Image from '../../components/pageContent/Image'
import Video from '../../components/pageContent/Video'

import './Media.css'

class Media extends Component {

    whatType(file) {


        switch (file.contentType) {

            case 'image/jpeg' || 'image/png' || 'image/gif' || 'image/webp':
                return Image

            case 'video/mp4':
                return Video

            default:
                return Image

        }

    }


    render() {
        const { caption } = this.props
        const { title, file } = this.props.data.fields

        const Component = this.whatType(file)

        return (

            <div>
                <Component  {...this.props} />

                {caption && <div className="caption">
                    {title}
                </div>
                }
            </div>

        );
    }
}


export default Media;